module.exports = __webpack_public_path__ + "images/2c3fe3a.jpg";